import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'

import { DomainContext } from '../../domain-repository/DomainRepository'

import { setPageId } from '../../services/Metrics'

import { applyValuesToString, buildTemplateFactory, DynamicContent, templateApplyFunctions, templateApplyValues } from "./utils"

import { FooterWithPrice } from '../../components/Footer'
import DriverInfoHeader from '../../components/PageHeader'

const PAGE_TEMPLATE_ID = 1

const valuesKeys = {
  '{{pricePerDay}}': (obj) => obj.pricePerDay,
  '{{priceTotal}}': (obj) => obj.totalPrice,
  '{{tollDepositValue}}': (obj) => obj.tollDepositValue,
  '{{tollsMessage}}': (obj) => obj.tollsMessage,
};

const functionKeys = {
  '!isExpandOpen!': obj => obj.seeMoreOpen,
  '!isTollsValueInPreAuth1!': (obj) => obj.appFlowConfigs.isTollsValueInPreAuth1,
  '!hasExtra!': obj => obj.hasExtra,
  '!isExtraPerDay!': obj => obj.pricePerDay,
};

export function buildTemplate(templateString, valuesObj, localizations) {
  return buildTemplateFactory(templateString, valuesObj, localizations, functionKeys, valuesKeys)
}

function Template1Page({ match, history }) {
  const { t } = useTranslation()

  const {
    getComfortExtras,
    addExtra,
    removeExtra,
    getQuantityOfExtra,
    isCorporate,
    appFlowConfigs,
    getCorporateExtras,
    flowNextRoute,
    reservation,
    paymentOption,
    tollDepositValue,
    pages,
    localizations,
    rentalAgreementQuoteValue,
    flowPreviousRoute,
    saveSessionExtra,
  } = useContext(DomainContext)

  const [tollsCardPopup, setTollsCardPopup] = useState(null)

  const [currentPage, setCurrentPage] = useState(null)
  const [extra, setExtra] = useState(null)
  const [seeMoreOpen, setSeeMoreOpen] = useState(false)

  const hasExtra = extra ? getQuantityOfExtra(extra) > 0 : false;

  const page = currentPage ? currentPage.description : ''

  useEffect(() => {
    if (pages) {
      const _currentPage = pages.find(p => p.url === match.url)
      setCurrentPage(_currentPage)

      const _extra = getCorporateExtras([_currentPage.extraId])[0];
      setExtra(_extra)
      setPageId({ pageId: _currentPage.pageId })
    }
  }, [pages, isCorporate, getCorporateExtras, getComfortExtras, t])

  function getNextStepUrl() {
    return flowNextRoute()
  }

  const handleContentClick = useCallback((e) => {
    if (e.target.id === '_ADD-EXTRA_') {
      if (hasExtra) {
        removeExtra(extra)
      } else {
        addExtra(extra)
      }
    }
    if (e.target.id === '_SEE-MORE_') {
      setSeeMoreOpen(v => !v)
    }
  }, [hasExtra, removeExtra, addExtra, extra])

  const handleNextClick = useCallback(() => {
    saveSessionExtra({
      extraId: extra.extraID,
      price: extra.totalPrice,
      acquired: hasExtra,
      removedInReview: false,
      pageId: currentPage.id,
    })
    history.push(getNextStepUrl())
  }, [history, extra, hasExtra, currentPage, getNextStepUrl, saveSessionExtra])

  const data = extra ? {
    pricePerDay: extra.pricePerDay || extra.totalPrice,
    totalPrice: extra.totalPrice,
    tollDepositValue,
    appFlowConfigs,
    hasExtra,
    tollsMessage: t('tollsPaymentAuth1', { value: appFlowConfigs.tollsValueInPreAuth1 }),
    seeMoreOpen,
  } : null

  const htmlContent = currentPage && data ? buildTemplate(currentPage.htmlContent, data, localizations) : null

  return extra && htmlContent ? (
    <div>
      <DriverInfoHeader
        title={t('comfort')}
        active={2}
        progress={'50%'}
        handleLogoClick={() => history.push('/start')}
      />
      <main>
        <div className="container container-large">
          <div className="main safe-bottom-padding">
            <DynamicContent onClick={handleContentClick} content={htmlContent} />
          </div>
        </div>
        <FooterWithPrice
          totalPrice={rentalAgreementQuoteValue}
          totalPriceLabel={t('total')}
          handleNextClick={() => history.push(getNextStepUrl())}
          handlePrevClick={() => flowPreviousRoute(history)}
        />
      </main>
    </div>
  ) : null
}

export default Template1Page
